
import React, { Component } from 'react';
import { Table, Badge, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import MainLayout from '../layout/layout';
import {  Redirect } from 'react-router-dom';
import RolesType from '../utils/roles';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomerInfoService from '../Services/CustomerInformationService/customerInformationService';
import { ClipLoader } from 'react-spinners';
import { css } from 'react-emotion';
import APIService from '../Services/APIService/apiService';
import Viventium from '../APIComponent/Viventium';
import Geotab from '../APIComponent/Geotab';
import EasyScheduling from '../APIComponent/EasyScheduling';
import { faPlus, faTrash, faExclamationTriangle } from '../../node_modules/@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ECustomSetting from '../utils/ECustomSettings';
import Jamis from '../APIComponent/Jamis';
import QuickPay from '../APIComponent/QuickPay';
import OnShift from  '../APIComponent/OnShift';
import Report from '../APIComponent/Report';
import Arbor from '../APIComponent/Arbor';
import Adrenalin from '../APIComponent/Adrenalin';
import Xero from '../APIComponent/Xero';
import ExportToFTP from '../APIComponent/ExportToFTP';
import DisconnectedDevice from '../APIComponent/DisconnectedDevice';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';


const SelectedCss = {
    backgroundColor: '#6DB3E1',
    color: 'white'
}
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const NotSelectedCss = {

}

class API extends Component{

    constructor(props){
        super(props);
        this.getAPISettings = this.getAPISettings.bind(this);
        this.state = {
            Filter: {
                FilterCompanyCode: "",
            },    
            modal: {warning: false, id: null, success: false},
            CompanyCode: "",
            MaxUser: "",
            ProductCode: "",
            UsersActive: "",
            ExpirationDate:"",
            LocationData: { pending: false, value: [] },
            APISettingData: { pending: false, value: [] },
            APISettingDataADD: { pending: false, value: [] },
            SelectLocations: "",
            messageDelete:"",
            loading: false,
            SelectedID: false,
            SelectedName: false,
            SelectAPISettings: "0",
            ADD: false,
            loadingADD: false,
            loadingWarning: false,
            blocking: false,
            isAutenticated: true,
            ShowMessage: false
        };
        this.companyCodeValue = this.companyCodeValue.bind(this);
        this.hanldeKeyPressCompanyCode = this.hanldeKeyPressCompanyCode.bind(this);
        this.getCustomerInfo = this.getCustomerInfo.bind(this);
        this.getDetails = this.getDetails.bind(this);
        this.updateList = this.updateList.bind(this);
        this.toggleSuccess = this.toggleSuccess.bind(this);
        this.handleAPISetting = this.handleAPISetting.bind(this);
        this.toggleWarning = this.toggleWarning.bind(this);
        // this.ValidateMaxUser = this.ValidateMaxUser.bind(this);
    }

    companyCodeValue(e) {
        e.preventDefault();               
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterCompanyCode = e.target.value;
        this.setState(stateCopy);
    }    
    getCustomerInfo(){
        var CompanyCode = this.state.Filter.FilterCompanyCode;
        var email = sessionStorage.getItem('email');
        var that = this;
        this.setState({
            loading: true
        });
        var DataResult = CustomerInfoService.getCustomerInformation( CompanyCode, email);          
        DataResult.then(function(data){
            if(data.statusText === "OK"){               
              that.setState({
                 CompanyName: data.data.CompanyName,
                 MaxUser: data.data.MaxUsers,
                 ProductCode: data.data.ProductCode,
                 UsersActive: data.data.UsersActive,
                 ExpirationDate: data.data.ExpirationDate,                 
                 loading: false
              });
              that.getAPISettings(CompanyCode);              
            }           
        }).catch((error) => {
            that.setState({
                CompanyName: "",
                MaxUser: "",
                ProductCode: "",
                UsersActive: "",
                ExpirationDate: "",                 
                loading: false
             });
             if(error.response)
             {
                 if(error && error.response && error.response.data.Message === "500") {               
                     toast.error("Error Data Base(Error: 500)", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data === "NotReseller") {    
                    toast.error("This User does not have permission!", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data.Message === "400"){ 
                    toast.error("API Error for Reseller", { className: {
                        opacity: 0.8
                    }});
                 }else if(error.response.status === 401){ 
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();  
                        this.setState({ isAutenticated: false },
                        ()=>{                               
                            this.forceUpdate();
                        })              
                 }   
             }else{
                 toast.error("Code Error", { className: {
                     opacity: 0.8
                 }});
             }
        });        
    }
    showSuccessMessage = () => {        
        toast.success("API Setting  Deleted!", { className: {
          opacity: 0.8
        }});
    }
    getAPISettings = (CompanyCode) => {
        var email = sessionStorage.getItem('email');
        var that = this;
       // let toastrMsg = () => setTimeout(()=>{that.ShowMessageToast()}, 0);
        this.setState({
            loading: true
        });
        var DataResult = APIService.getAPISettings( CompanyCode, email);
        DataResult.then(function(data) {
            if(data.statusText === "OK"){                
                that.setState({
                 APISettingData: { loading: false, value: data.data },              
                 loading: false,
                 SelectedID: data.data[0].ID,
                 SelectedName: data.data[0].NAME,
                });
            }
        }).catch((error) => {
            that.setState({
                APISettingData: { loading: false, value: []},              
                loading: false,
                SelectedName: false
             }); 
             if(error.response)
             {
                 if(error && error.response && error.response.data.Message === "500") {               
                     toast.error("Error Data Base(Error: 500)", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data === "NotReseller") {    
                    toast.error("This User does not have permission!", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data.Message === "400"){ 
                    toast.error("API Error for Reseller", { className: {
                        opacity: 0.8
                    }});
                 }else if(error.response.status === 401){ 
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();  
                        this.setState({ isAutenticated: false },
                        ()=>{                               
                            this.forceUpdate();
                        })              
                 }   
             }else{
                 toast.error("Code Error", { className: {
                     opacity: 0.8
                 }});
             }
        });        
    }
    hanldeKeyPressCompanyCode(e){
        //e.preventDefault();
        var CompanyCode = this.state.Filter.FilterCompanyCode;
        if(e.keyCode === 13){
            if(CompanyCode !== "")
            { 
               this.setState({
                   ADD: true
               }); 
               this.getCustomerInfo();                             
            }
            else{
                toast.warning("CompanyCode cant not be Empty!", { className: {
                    opacity: 0.8
                }});
            }                
        }      
    }
    getDetails(e, id){
        e.preventDefault();
        var name = this.state.APISettingData.value.find(x=>x.ID === id);
        this.setState({
            SelectedID: id ,
            SelectedName: name.NAME         
        });
    }
    updateList(elemt){
      var list = this.state.APISettingData.value;     
      var Result = list.findIndex(x=>x.ID === elemt.ID);
      list[Result] = elemt;
      list[Result].VALUE = JSON.stringify(list[Result].VALUE);      
      let stateCopy = Object.assign({}, this.state);
      stateCopy.APISettingData.value = list;
      this.setState(stateCopy);       
    }
    toggleWarning(id){        
        this.setState({
            modal: { warning : !this.state.modal.warning, success: false, id:id} 
        }); 
    }
    toggleSuccess() {
        var ECustomSettingResult = ECustomSetting;
        var Data = this.state.APISettingData.value;
        var DataResult = [];
        for(var key in ECustomSettingResult){
            let target = {value:ECustomSettingResult[key].description.name, description:ECustomSettingResult[key].description.realName};
            var objResult = Data.find(x=>x.ALIAS === target.value);
            if(objResult === null || objResult === undefined || objResult === ""){
                DataResult.push(target);
            }            
        }
          this.setState({
            modal: { warning : false, success: !this.state.modal.success},  
            APISettingDataADD: { value: DataResult }            
        }); 
    }
    handleAPISetting(event) {
        var value = event.target.value;
        if (value !== "0") {            
            this.setState({
                SelectAPISettings: value
            }, ()=> console.log());
        }
    }
    ADDAPI(e){
        e.preventDefault();
        var CompanyCode =  this.state.Filter.FilterCompanyCode;
        var email = sessionStorage.getItem('email');
        var apiname = this.state.SelectAPISettings;        
        var that = this;        
        this.setState({
            loadingADD: true,
           // ShowMessage: !this.state.ShowMessage
        });
        if(apiname === null || apiname === undefined || apiname === "" || apiname === "0")
        {
            that.setState({          
                loadingADD: false,
            });
            toast.warning("API Setting cant not be Empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        var DataResult = APIService.SaveAPISetting(CompanyCode, email, apiname);
        DataResult.then(function(data){
            if(data.statusText === "OK" && data.data !== "NoDB"){
                that.setState({          
                    loadingADD: false,
                    APISettingDataADD: { value: [] },
                    modal: { success: false },
                    SelectAPISettings: "0",
                    ShowMessage:false
                });     
                toast.success("ADD OK!", { className: {
                    opacity: 0.8
                }});          
                that.getAPISettings(CompanyCode);             
            }else if(data.data === "NoExist"){
                that.setState({            
                    loadingADD: false,
                    APISettingDataADD: { value: [] },
                    modal: { success: false },
                    SelectAPISettings: "0"
                 });
                toast.error("API Setting dosen't exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "ADD_TENANT_ERROR"){
                that.setState({            
                    loadingADD: false,
                    APISettingDataADD: { value: [] },
                    modal: { success: false },
                    SelectAPISettings: "0"
                 });
                toast.error("Tenant Error(ADD)!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "AuditError"){
                that.setState({            
                    loadingADD: false,
                    APISettingDataADD: { value: [] },
                    modal: { success: false },
                    SelectAPISettings: "0"
                 });
                toast.error("Not Saved!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {
            that.setState({             
                loadingADD: false,
                APISettingDataADD: { value: [] },
                modal: { success: false },
                SelectAPISettings: "0"
             });  
             if(error.response)
             {
                 if(error && error.response && error.response.data.Message === "500") {               
                     toast.error("Error Data Base(Error: 500)", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data === "NotReseller") {    
                    toast.error("This User does not have permission!", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data.Message === "400"){ 
                    toast.error("API Error for Reseller", { className: {
                        opacity: 0.8
                    }});
                 }else if(error.response.status === 401){ 
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();  
                        this.setState({ isAutenticated: false },
                        ()=>{                               
                            this.forceUpdate();
                        })              
                 }   
             }else{
                 toast.error("Code Error", { className: {
                     opacity: 0.8
                 }});
             }
        });     
    }
    DELLAPI = (e) => {
        e.preventDefault();
        var APISetting =  this.state.modal.id;
        var CompanyCode =  this.state.Filter.FilterCompanyCode;
        var email = sessionStorage.getItem('email');      
        var that = this;
        that.setState({
            loadingWarning: true,
            ShowMessage: true
        });
        var DataResult = APIService.DeleteAPISetting(CompanyCode, APISetting, email );        
        DataResult.then(function(data){           
            if(data.data === "OK") {  
                that.setState(state => {
                    return {          
                        loadingWarning: !state.loadingWarning,
                        modal: { success: false, warning: false, id: false },
                        ShowMessage: !state.ShowMessage
                    };
                }, () =>{                    
                    that.getAPISettings(CompanyCode);                   
                    setTimeout(that.showSuccessMessage(), 1000);
                });
            }else if(data.data === "NoExist"){
                that.setState({            
                    loadingWarning: false,
                    modal: { success: false, warning: false, id: false },
                 });
                toast.error("API Setting dosen't exist!", { 
                    className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Del_Tenant_Error"){
                that.setState({            
                    loadingWarning: false,
                    modal: { success: false, warning: false, id: false },
                 });
                toast.error("Audit Error!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {
            that.setState({             
                loadingWarning: false,
                modal: { success: false, warning: false, id: false },
             });
             if(error.response)
             {
                 if(error && error.response && error.response.data.Message === "500") {               
                     toast.error("Error Data Base(Error: 500)", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data === "NotReseller") {    
                    toast.error("This User does not have permission!", { className: {
                        opacity: 0.8
                    }});
                }else if(error && error.response && error.response.data.Message === "400"){ 
                    toast.error("API Error for Reseller", { className: {
                        opacity: 0.8
                    }});
                 }else if(error.response.status === 401){ 
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();  
                        this.setState({ isAutenticated: false },
                        ()=>{                               
                            this.forceUpdate();
                        })              
                 }   
             }else{
                 toast.error("Code Error", { className: {
                     opacity: 0.8
                 }});
             }
        });     
    }
    setOperation(e) {             
        this.toggleSuccess();                
    }
    renderAPIType()
    {
        var stateName = this.state.SelectedName;
        var viventium = "Viventium Setting";
        var GeotabName = "GeoTab Setting";
        var JamisName = "Jamis Setting";
        var QuickPayName = "QuickPay Setting";
        var OnShiftName = "OnShift Setting";
        var ReportName = "Reports Email";
        var ArborName = "Arbor Setting";
        var AdrenalinName = "Adrenalin Setting";
        var XeroName = "Xero Setting";
        var ExportToFTPName = "Export to FTP";
        var DisconnectedDeviceName = "Disconnected Devices";
        var EasySchedulingSetting = "Easy Scheduling Setting";      

        if(stateName && stateName.trim().toUpperCase() === viventium.trim().toUpperCase())
            return <Viventium DataVivemtium = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>;         

        else if(stateName && stateName.trim().toUpperCase() === GeotabName.trim().toUpperCase())
           return <Geotab DataGeoTab = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>;  
           
        else if(stateName && stateName.trim().toUpperCase() === EasySchedulingSetting.trim().toUpperCase())
           return <EasyScheduling DataEasyScheduling = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>;      
        
        else if(stateName && stateName.trim().toUpperCase() === JamisName.trim().toUpperCase())
           return <Jamis DataJamis = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>;      
        
        else if(stateName && stateName.trim().toUpperCase() === QuickPayName.trim().toUpperCase())
           return <QuickPay DataQuickPay = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>;  
           
        else if(stateName && stateName.trim().toUpperCase() === OnShiftName.trim().toUpperCase())
           return <OnShift DataOnShift = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>;  

        else if(stateName && stateName.trim().toUpperCase() === ReportName.trim().toUpperCase())
           return <Report DataReport = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>;  

        else if(stateName && stateName.trim().toUpperCase() === ArborName.trim().toUpperCase())
           return <Arbor DataArbor = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>; 
           
        else if(stateName && stateName.trim().toUpperCase() === AdrenalinName.trim().toUpperCase())
           return <Adrenalin DataAdrenalin = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>; 

        else if(stateName && stateName.trim().toUpperCase() === XeroName.trim().toUpperCase())
           return <Xero DataXero = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>; 

        else if(stateName && stateName.trim().toUpperCase() === ExportToFTPName.trim().toUpperCase())
           return <ExportToFTP DataExportToFTP = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>; 

        else if(stateName && stateName.trim().toUpperCase() === DisconnectedDeviceName.trim().toUpperCase())
           return <DisconnectedDevice DataDisconnectedDevice = { this.state.APISettingData.value }  CompanyCode = {this.state.Filter.FilterCompanyCode} SetObject = {this.updateList}/>; 
 
    }
    renderImportFileRow()
    {
        let dataResult = RolesType;
        var temp = Object.keys(dataResult);    
        if(sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1] || sessionStorage.getItem("rol") === temp[2] || sessionStorage.getItem("rol") === temp[4] ||
           sessionStorage.getItem("rol") === temp[5])
        {
            return (<div>
                        <div className="row">
                        <div className="col-2" >
                            <div className="card Logs" style={{ height: "800px"}}>
                                <div className="card-header" style={{ height: "60px"}}>
                                    <div className="row">
                                        <div className="col-lg-10 col-md-10 col-sm-10">
                                            <label style={{'fontWeight': 'bold'}}>APIs</label>
                                        </div>
                                        {
                                            this.state.ADD
                                            ?
                                            <div className="col-lg-2 col-md-2 col-sm-2">
                                             <a title="Add API" onClick={(e) => { this.setOperation(e) }}><Badge color="success"><FontAwesomeIcon icon={faPlus} /></Badge></a>&nbsp;&nbsp;
                                            </div>
                                            :
                                            <div></div>
                                        }                                      
                                    </div>
                                </div>
                                <div className="card-body">
                                    <Table borderless responsive size="sm" striped>
                                        <tbody style={{ 'cursor': 'pointer'}} >
                                        {
                                            this.state.loading
                                            ? <tr className=""></tr>
                                            :
                                            this.state.APISettingData.value.map((item, index) => {
                                                return  <tr key={item.ID} style={this.state.SelectedID === item.ID  ? SelectedCss : NotSelectedCss}  id={item.ID} onClick={(e)=>this.getDetails(e, item.ID)}>
                                                            <td style={{'fontWeight': 'normal'}}>{item.NAME}</td> 
                                                            <td>
                                                                <a title="Delete APISettings" onClick={(e) => { this.toggleWarning(item.ALIAS) }}><Badge color="danger"><FontAwesomeIcon icon={faTrash} /></Badge></a>
                                                            </td>                                                  
                                                        </tr>                                          
                                            })

                                        }
                                        </tbody>                                      
                                    </Table>
                                </div>
                            </div>
                        </div>
                        <div className="col-10">
                            <div className="row">
                                <div className="col-12">
                                    { this.renderMigration()}
                                </div> 
                            </div><br/>
                            <div className="row">
                                <div className="col-12">
                                     { this.renderAPIType()}      
                                </div>                                  
                            </div>
                        </div>        
                    </div>
                    </div>);
        }else{
            return (<Redirect to={'/login'}/>)
        }
    }
    ValidateDate(d){

        var ActualDate = new Date();
        var DBDate = new Date(d);
        
        // Compara solo las fechas => no las horas!!
        ActualDate.setHours(0,0,0,0);

        let ret =  DBDate < ActualDate ? "badge badge-pill badge-danger": "badge badge-pill badge-light";        
        return ret;

    }
    ValidateMaxUser(MaxUser, ActiveUsers){             
        let ret =  parseInt(MaxUser, 10) < parseInt(ActiveUsers, 10) ? "badge badge-pill badge-danger": "badge badge-pill badge-light";        
        return ret;
    }
    renderMigration()
    {
       return (<div>
                 <div className="card Logs">
                    <div className="card-body" >                
                        <div className="row">
                            <div className="col-2">
                                <h4><span className="badge badge-info">Customer Information</span></h4>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 offset-md-1" style={{'paddingBottom': '0.8rem', 'paddingRight': '1.8rem', 'textAlign': 'right'}}>
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Company Code</label>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 " style={{'paddingBottom': '0.8rem'}}>
                                 <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                    <input className="form-control" name="CompanyCode" id="CompanyCode" type="text" onKeyDown={ this.hanldeKeyPressCompanyCode}  onChange={this.companyCodeValue} value={this.state.Filter.FilterCompanyCode ? this.state.Filter.FilterCompanyCode : ""}/>
                                 </div>
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 " style={{'paddingBottom': '0.8rem'}}>
                                {/* <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loading}
                                /> */}
                            </div>
                        </div>
                        <div className="row">                                 
                            <div className="col-3" style={{'paddingBottom': '0.8rem'}}>
                                <span className="badge badge-pill badge-light">Company Name: {this.state.CompanyName}</span>
                            </div>                        
                            <div className="col-3" style={{'paddingBottom': '0.8rem'}}>
                                <span className="badge badge-pill badge-light">Max Users: {this.state.MaxUser}</span>
                            </div>
                            <div className="col-3" style={{'paddingBottom': '0.8rem'}}>
                                <span className={this.ValidateMaxUser(this.state.MaxUser,this.state.UsersActive)} >Users Active: {this.state.UsersActive}</span>                            
                            </div>
                        </div>
                        <div className="row">                           
                            <div className="col-3 offset-md-3">
                                <span className="badge badge-pill badge-light">Product Code: {this.state.ProductCode}</span>
                            </div>
                            <div className="col-3">
                                <span className={this.ValidateDate(this.state.ExpirationDate.replace("T" , " "))} >Expiration Date: {this.state.ExpirationDate.replace("T" , " ")}</span>                                
                            </div>
                        </div>
                    </div>
                 </div>

                 

             </div>);
        
    }

    render(){

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }

        let optionItemsApiSetttings = this.state.APISettingDataADD.value.map((item, index) => {
            return <option key={item.value} className="dropdown-item" href="#" value={item.value}>{item.description}</option>
        });


        return (
            <BlockUi tag="div" blocking={this.state.loading} loader={ <div style={{ paddingTop: '100px'}} className="loader"></div>} >          
             <MainLayout/><ToastContainer hideProgressBar autoClose={6000} />
                <div className="container-fluid" >
                    {
                        this.renderImportFileRow()
                    }
                </div>

                <Modal isOpen={this.state.modal.success} toggle={this.toggleSuccess}
                    
                    aria-labelledby="contained-modal-title-lg"
                    className={"modal-dialog modal-notify modal-success"}
                    
                >
                    <ModalHeader toggle={this.toggle}> <p className="heading lead">Add</p>
                        </ModalHeader>
                    <ModalBody className={"text-center"} style={{ 'maxHeight': '500px', 'overflowY': 'auto' }}>

                            <div className="row" >
                                <div className="col-lg-3 col-md-3 col-sm-3">
                                    <label className="control-label" style={{ 'paddingTop': '10px', 'float': 'right', 'fontWeight': 'bold' }}>Api Setting</label>
                                </div>
                                <div className="col-lg-8 col-md-8 col-sm-8">
                                    <select className="form-control" onChange={this.handleAPISetting} value={this.state.SelectAPISettings}>
                                        <option className="dropdown-item" href="#" value="0" >Select Api Setting</option>
                                        { optionItemsApiSetttings }
                                    </select>
                                </div>
                            </div>
                                
                        </ModalBody>
                    <ModalFooter className={"modal-footer justify-content-right"}>
                        <ClipLoader
                            className={override}
                            sizeUnit={"px"}
                            size={30}
                            color={'#00C851'}
                            loading={this.state.loadingADD}
                        />
                        {
                            this.state.loadingADD
                            ?
                            <div>
                                <a className="btn btn-success disabled" onClick={(e) => { this.ADDAPI(e) }} disabled>OK</a>
                                <a className="btn btn-outline-success waves-effect disabled" onClick={this.toggleSuccess } disabled>CLOSE</a>
                            </div>                             
                            :
                            <div>
                                <a className="btn btn-success" onClick={(e) => { this.ADDAPI(e) }}>OK</a>
                                <a className="btn btn-outline-success waves-effect" onClick={this.toggleSuccess }>CLOSE</a>
                            </div> 
                            }
                    </ModalFooter>                   
                </Modal>
                <Modal isOpen={this.state.modal.warning} toggle={this.toggleWarning}
                   
                   aria-labelledby="contained-modal-title-lg"
                   className={"modal-dialog modal-notify modal-warning"}
                   size="sm"
               >
               <ModalHeader toggle={this.toggle}> <p className="heading lead">Warning</p>
                   </ModalHeader>
               <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                       <p><FontAwesomeIcon color="#FFBB33"  icon={faExclamationTriangle} size="3x" /></p>
                       <p>Are you sure?</p>
               </ModalBody>
               <ModalFooter className={"modal-footer justify-content-right"}>
               <ClipLoader
                   className={override}
                   sizeUnit={"px"}
                   size={30}
                   color={'#FF8800'}
                   loading={this.state.loadingWarning}
               />
                   { this.state.Button }
                   {
                       this.state.loadingWarning
                       ? 
                        <div>
                            <a className="btn btn-warning disabled" onClick={(e) => { this.DELLAPI(e) }} disabled>OK</a>
                            <a className="btn btn-outline-warning waves-effect disabled" onClick={this.toggleWarning } disabled>CLOSE</a>
                        </div>
                       : 
                        <div>
                            <a className="btn btn-warning" onClick={(e) => { this.DELLAPI(e) }}>OK</a>
                            <a className="btn btn-outline-warning waves-effect" onClick={this.toggleWarning}>CLOSE</a>
                        </div>
                       }
               </ModalFooter>
           </Modal>
            </BlockUi>       
        );
        
    }
}

export default API;


// WEBPACK FOOTER //
// ./src/APIComponent/api.jsx